import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const CompetitionContext = createContext(null);
const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useCompetition = () => {
  const context = useContext(CompetitionContext);
  if (!context) {
    throw new Error('useCompetition must be used within CompetitionProvider');
  }
  return context;
};

// Stages: setup, registration, live, complete
export const CompetitionProvider = ({ children }) => {
  const [stage, setStage] = useState('setup'); // setup | registration | live | complete
  const [competition, setCompetition] = useState(null);
  const [stats, setStats] = useState({
    totalRegistered: 0,
    confirmed: 0,
    seatsRemaining: 0,
    activeParticipants: 0,
    seatLimit: 0
  });

  const loadCompetitionState = useCallback(async () => {
    try {
      // Load active competition
      const res = await axios.get(`${API_URL}/api/admin/competition-state`, { withCredentials: true });
      if (res.data) {
        setCompetition(res.data.competition);
        setStage(res.data.stage || 'setup');
        setStats(res.data.stats || stats);
      }
    } catch (e) {
      // No active competition = setup stage
      setStage('setup');
    }
  }, []);

  useEffect(() => {
    loadCompetitionState();
  }, [loadCompetitionState]);

  const refreshState = () => loadCompetitionState();

  return (
    <CompetitionContext.Provider value={{ stage, setStage, competition, setCompetition, stats, refreshState }}>
      {children}
    </CompetitionContext.Provider>
  );
};

export default CompetitionContext;
